import apiClient from "@/services/apiClient";

export default {
    data() {
        return {
            timecardApiUrl: process.env.VUE_APP_TIMECARD_API_URL
        }
    },
    methods: {
        async getEvents(from, to) {            
            if (!to) {
                to = from;
            }
            
            const {data} = await apiClient.get(`${this.timecardApiUrl}/calendar/${from}/${to}`);

            return data;
        },

        async getEventsForEmployee(username) {
            const {data} = await apiClient.get(`${this.timecardApiUrl}/calendar/username/${username}/all`);

            return data;
        },
        async createEvent(payload) {
            const {data} = await apiClient.post(`${this.timecardApiUrl}/calendar`, payload);

            return data;
        },
        async deleteEvent(id) {
            const {data} = await apiClient.delete(`${this.timecardApiUrl}/calendar/${id}`);

            return data;
        },
        async getEmployees() {
            const {data} = await apiClient.get(`${this.timecardApiUrl}/calendar/usernames`);

            return data;
        }
    }
};